var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 256,
    viewBox: "0 0 152 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4439 237.649V193.251C59.4439 189.829 56.6813 187.066 53.2598 187.066H11.5438C6.37982 187.066 2.17209 182.879 2.17209 177.694V123.54C2.17209 120.033 5.01974 117.186 8.52618 117.186H42.9318",
    stroke: "#E09234",
    strokeWidth: 3.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4439 237.649V193.251C59.4439 189.829 56.6813 187.066 53.2598 187.066H11.5438C6.37982 187.066 2.17209 182.879 2.17209 177.694V123.54C2.17209 120.033 5.01974 117.186 8.52618 117.186H42.9318",
    stroke: "#E09234",
    strokeWidth: 3.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7469 67.8984V113.593C90.7469 117.121 93.5945 119.969 97.1222 119.969H140.05C145.384 119.969 149.698 124.283 149.698 129.618V185.365C149.698 188.978 146.765 191.911 143.152 191.911H107.727",
    stroke: "#E09234",
    strokeWidth: 3.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7469 67.8984V113.593C90.7469 117.121 93.5945 119.969 97.1222 119.969H140.05C145.384 119.969 149.698 124.283 149.698 129.618V185.365C149.698 188.978 146.765 191.911 143.152 191.911H107.727",
    stroke: "#E09234",
    strokeWidth: 3.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9725 255.267C105.963 235.693 108.917 207.766 88.5793 185.344C79.335 175.143 68.8582 166.769 57.6163 159.798C30.6061 143.029 19.853 119.247 25.8034 89.7684C29.9261 69.3015 49.1159 52.4477 67.1156 53.4678C42.7405 76.6764 42.4855 102.669 67.0093 123.434C79.8875 134.336 94.2321 142.88 106.685 154.421C117.523 164.495 127.448 175.61 128.276 195.503C129.636 228 109.618 254.842 79.9725 255.246V255.267Z",
    fill: "url(#paint0_linear_8097_3713)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7684 27.3262C75.786 34.7436 81.4814 37.889 89.3018 38.8029C84.074 42.586 80.1638 47.6655 77.5924 54.0415C73.5334 49.302 68.1994 45.5402 61.6328 42.756C69.2407 40.2056 72.6621 35.3386 72.7471 27.3262H72.7684Z",
    fill: "url(#paint1_linear_8097_3713)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6394 12.3641C87.4954 13.5118 83.479 13.1505 80.015 18.1663C80.9076 12.1729 78.4637 8.92112 75.7223 5.2018C80.3975 5.13804 84.924 5.77564 87.4317 0.589844C88.218 4.883 86.7941 9.57997 91.6394 12.3641Z",
    fill: "url(#paint2_linear_8097_3713)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.202 3.947L105.941 1.58789C105.941 1.58789 106.09 1.58789 106.133 1.6304L109.214 4.77588C109.639 5.2222 109.745 5.88105 109.469 6.43363L107.429 10.323C107.429 10.323 107.323 10.4292 107.259 10.408L104.093 9.87666C102.796 9.66413 101.776 8.62272 101.585 7.30502L101.117 4.13828C101.117 4.13828 101.117 3.98951 101.202 3.96825V3.947Z",
    fill: "url(#paint3_linear_8097_3713)",
    stroke: "#54A39D",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8097_3713",
    x1: 24.2095,
    y1: 154.336,
    x2: 128.34,
    y2: 154.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8097_3713",
    x1: 61.6328,
    y1: 40.6732,
    x2: 89.3018,
    y2: 40.6732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8097_3713",
    x1: 75.7223,
    y1: 9.36744,
    x2: 91.6394,
    y2: 9.36744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8097_3713",
    x1: 107.97,
    y1: 3.46329,
    x2: 102.424,
    y2: 9.00819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogox);
export default __webpack_public_path__ + "static/media/logox.6cdf68c22a565132379b34a478d32d8a.svg";
export { ForwardRef as ReactComponent };